import firebaseApp from "../firebase/credenciales";
import React from "react";
import { useDataContext } from "../../Contexts/DataContext";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

//const {contextData} = useDataContext();
    

export default async function getProductos_orden(productofolio) {
    

  //console.log(valor);
    const productos =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Ordenes_productos/"+productofolio+"/Productos".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      productos.push(doc.data());
    });
    return productos;
    

}


//"+productofolio+"
